import { useMutation } from '@tanstack/react-query'
import { mutateCompanyPositionTemplateBlock } from 'api/worker'
import { useOptimisticUpdate } from 'hooks/useOptimisticUpdate'
import { MutationOptions, QueryData } from 'queries/types'
import { workerKeys } from './keys'
import { useWorkerProfile } from './useWorkerProfile'

type WorkerProfile = QueryData<typeof useWorkerProfile>

export function usePositionTemplateBlockMutation(
  workerId: number,
  options: MutationOptions<
    typeof mutateCompanyPositionTemplateBlock,
    [WorkerProfile]
  > = {}
) {
  return useMutation({
    ...useOptimisticUpdate(options, [
      {
        queryKey: workerKeys.profile(workerId),
        updater: (variables, previous) => {
          if (previous === undefined) {
            return previous
          }

          return {
            ...previous,
            worker: {
              ...previous.worker,
              positionTemplateBlocks: variables.positionTemplateBlocks.map(
                (item) => ({
                  name: '',
                  positionTemplateId: item.positionTemplateId,
                  id: item.positionTemplateId.toString(),
                  blocked: item.blocked,
                })
              ),
            },
          }
        },
      },
    ]),
    mutationFn: mutateCompanyPositionTemplateBlock,
  })
}
